import Root from "./routes/root";
import store from "./redux/store";
import { Provider } from "react-redux";
import { Alerts, Loader, Modaal, Toasts, SnackBar } from "./components";
import { BrowserRouter } from "react-router-dom";

import { AlertProvider, ModalProvider, ToastProvider, SnackBarProvider } from "./contexts";
import useAutoLogout from "./hooks/useAutoLogout";


function App() {
  // const apiUrl = process.env.REACT_APP_API_BASE_URL;

  // console.log("apiUrl", apiUrl);

  return (
    <Provider store={store}>
      <BrowserRouter future={{ v7_relativeSplatPath: true }}>
        <AlertProvider>
          <ToastProvider>
            <SnackBarProvider >
              <ModalProvider>
                <AutoLogoutWrapper />
                <Alerts.Alerts />
                <Toasts.ToastsContainer />
                <SnackBar.SnackContainer />
                <Modaal.Modaal1 />
                <Modaal.CookiesPolicyModal />
                <Root />
                <Loader.Loader
                  height={100}
                  width={100}
                  type="puff"
                  color="#4fb1ad"
                  className="loader"
                  ariaLabel="dna-loading"
                  duration={5000}
                />

              </ModalProvider>
            </SnackBarProvider>
          </ToastProvider>
        </AlertProvider>
      </BrowserRouter>
    </Provider>
  );
}

const AutoLogoutWrapper = () => {
  useAutoLogout();
  return null; // No UI needed
};

export default App;
